<template>
  <div :class="themeStyleVs === 2 ? 'hot_page black_version' : 'hot_page'">
    <header id="hdMain" :class="mainScrollShow ? 'sticky_header' : ''">
      <div class="header_main">
        <div class="navg_box" :style="`backdrop-filter: blur(${filterNum}px)`">
          <div class="bg_box">
            <navigation
              :text="'策略详情'"
              :searchShow="true"
              :shareImgShow="clCondition && clCondition.isCl && clCondition.s_audit === 1"
              @shareBtn="shareBtn"
            ></navigation>
          </div>
        </div>
        <div class="hd_main" v-if="!allNotData && !notHd">
          <div class="cl_tit_main">
            <div class="text" v-if="clCondition">{{ clCondition.s_name }}</div>
            <div class="btn vip-parent" v-if="clCondition && clCondition.isCl" @click="goEdit">
              编辑 <i class="vip-icon" v-show="!isVip && vipIcon"></i>
            </div>
            <div
              class="btn"
              v-if="clCondition && !clCondition.isCl && !clCondition.isGz"
              @click="gzFn"
            >
              关注
            </div>
            <div
              class="btn"
              v-if="clCondition && !clCondition.isCl && clCondition.isGz"
              @click="delGz"
            >
              已关注
            </div>
          </div>
          <div class="introduce_box" v-if="clCondition">{{ clCondition.s_desc }}</div>
          <div class="msg_main clearfix">
            <ul class="clearfix">
              <li>
                <p v-if="hqData" :class="[judgeColor(hqData.RiZhangFu)]">
                  {{ toFixedNum(hqData.RiZhangFu * 100, 2, '%') }}
                </p>
                <p>日涨幅</p>
              </li>
              <li>
                <p v-if="hqData">{{ hqData.XinHaoShuLiang || 0 }}只</p>
                <p>今日信号数</p>
              </li>
              <li>
                <p v-if="clCondition">{{ clCondition.creator }}</p>
                <p>作者</p>
              </li>
            </ul>
          </div>
          <div class="divisor_main">
            <div class="tit_box" @click="checkDivisor">
              · 因子池内容
              <span v-if="yzNameArr.length > 2">
                <van-icon name="arrow-down" v-if="num === 2" />
                <van-icon name="arrow-up" v-else />
              </span>
            </div>
            <div class="yzc_list">
              <van-row gutter="8">
                <template v-for="(item, index) in yzNameArr">
                  <van-col span="12" :key="index" v-if="index < num">
                    <p class="li one-txt-cut">{{ item.name }}</p>
                  </van-col>
                </template>
              </van-row>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div :class="mainScrollShow ? 'contant_main scrollBox' : 'contant_main'" v-if="!notHd">
      <div class="main_all" v-if="!allNotData">
        <ul class="nav_list_main">
          <li
            :class="navId === index ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @click="checkNav(index, item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- 评级报告 -->
        <div class="pj_main" id="pjbg">
          <div class="tit_box">
            <p>评级报告</p>
            <button :class="'tg' + typeInfo">
              {{
                typeInfo == 1
                  ? '历史表现优秀'
                  : typeInfo == 2
                  ? '历史表现欠佳'
                  : typeInfo == 3
                  ? '历史表现一般'
                  : ''
              }}
            </button>
          </div>
          <div class="xx_list">
            <ul>
              <li>
                <div class="left">1年内信号数量：</div>
                <div class="right" v-if="pgbgData">
                  {{ pgbgData.HistoryCount ? pgbgData.HistoryCount + '次' : '--' }}
                </div>
              </li>
              <li>
                <div class="left">最优平均涨跌幅：</div>
                <div class="right" v-if="pgbgData">
                  持股{{ pgbgData.BestAvgCycle }}天，涨幅
                  <span :class="[judgeColor(pgbgData.BestAvgRate)]">{{
                    toFixedNum(pgbgData.BestAvgRate * 100, 2, '%')
                  }}</span>
                </div>
              </li>
              <li>
                <div class="left">最大上涨概率：</div>
                <div class="right" v-if="pgbgData">
                  持股{{ pgbgData.MaxRiseCycle }}天，上涨概率
                  <span :class="[judgeColor(pgbgData.MaxRiseRate)]">{{
                    toFixedNum(pgbgData.MaxRiseRate * 100, 2, '%')
                  }}</span>
                </div>
              </li>
              <li>
                <div class="left">回测周期：</div>
                <div class="right" v-if="pgbgData">
                  {{ formtTime(getLastYear(), 'yyyy-MM-dd') }} 至
                  {{ formtTime(getLastDay(), 'yyyy-MM-dd') }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <p class="interval_box"></p>
        <!-- 今日信号 -->
        <div class="jrxh_box" id="jrxh">
          <div class="jrxhScroll_box" v-show="navId === 1 && jrxhNavShow">
            <table width="100%" cellspacing="0" cellpadding="0" v-if="xhQuery && xhList.length > 0">
              <tr>
                <th>
                  {{ clCondition.type_info == 2 ? 'ETF名称' : '股票名称' }}
                </th>
                <th
                  :class="[
                    xhfield === 'ZuiXinJia' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZuiXinJia' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZuiXinJia' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZuiXinJia')"
                >
                  最新
                </th>
                <th
                  :class="[
                    xhfield === 'ZhangFu' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZhangFu' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZhangFu' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZhangFu')"
                >
                  涨幅%
                </th>
                <th
                  :class="[
                    xhfield === 'ZhangDie' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZhangDie' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZhangDie' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZhangDie')"
                >
                  涨跌
                </th>
                <th>操作</th>
              </tr>
            </table>
          </div>
          <div class="tit" id="tit_main_height">
            <span>今日信号</span>
            <img
              :src="themeStyleVs === 2 ? blockScreenImg : screenImg"
              alt=""
              @click="screenPopupShow"
            />
          </div>
          <div class="table_content">
            <table width="100%" cellspacing="0" cellpadding="0" v-if="xhQuery && xhList.length > 0">
              <tr>
                <th>股票名称</th>
                <th
                  :class="[
                    xhfield === 'ZuiXinJia' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZuiXinJia' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZuiXinJia' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZuiXinJia')"
                >
                  最新
                </th>
                <th
                  :class="[
                    xhfield === 'ZhangFu' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZhangFu' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZhangFu' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZhangFu')"
                >
                  涨幅%
                </th>
                <th
                  :class="[
                    xhfield === 'ZhangDie' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZhangDie' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZhangDie' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZhangDie')"
                >
                  涨跌
                </th>
                <th>操作</th>
              </tr>
              <tr v-for="(item, index) in xhList" :key="index" @click="gogufs(item.Obj)">
                <td>
                  <p>{{ item.ZhongWenJianCheng }}</p>
                  <p>{{ item.JiaoYiDaiMa }}</p>
                </td>
                <td>{{ toFixedNum(item.ZuiXinJia, 2, '') }}</td>
                <td :class="[judgeColor(item.ZhangFu)]">{{ toFixedNum(item.ZhangFu, 2, '%') }}</td>
                <td>{{ toFixedNum(item.ZhangDie, 2, '') }}</td>
                <td>
                  <span
                    :class="item.joinShow ? 'active' : ''"
                    @click.stop="addStock(item, index)"
                    >{{ item.joinShow ? '已加入' : '加自选' }}</span
                  >
                </td>
              </tr>
            </table>

            <van-empty
              v-if="xhQuery && xhList.length <= 0"
              class="custom-image"
              :image="not_data"
              description="暂未获取到数据"
            />
            <div
              class="more_btn"
              @click="jrxhMore"
              v-show="xhQuery && xhList.length < xhObjCount && xhList.length > 0"
            >
              加载更多
            </div>
          </div>
        </div>

        <p class="interval_box"></p>
        <div class="hcsy_box" id="hcfx">
          <div class="tab_box">
            <ul>
              <li
                :class="hcSyTabId === index ? 'active' : ''"
                v-for="(item, index) in hcSyTab"
                :key="index"
                @click="checkHcSy(index)"
              >
                {{ item }} <i class="vip-icon-right" v-show="index == 1 && !isVip"></i>
              </li>
            </ul>
          </div>
          <!-- 回测分析hcfx -->
          <!-- <div class="hcfx_box" id="hcfx" v-if="hcSyTabId === 0"> -->
          <div class="hcfx_box" v-show="hcSyTabId === 0">
            <div class="head_box">
              <span v-if="clCondition">持股周期{{ clCondition.s_chigu_cycle }}天</span>
            </div>
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              v-if="hcfxData.length > 0 && defaultQuery"
            >
              <tr>
                <th></th>
                <th>持有期</th>
                <th>区间均涨幅</th>
                <th>盈亏比</th>
                <th>上涨概率</th>
              </tr>
              <tr v-for="(item, index) in hcfxData" :key="index">
                <td class="zybox-list-left">
                  <span class="zybox zf" v-if="index == maxAvgSectionIndex">涨幅</span>
                  <span class="zybox gl" v-if="index == maxRiseProbabilityIndex">概率</span>
                </td>
                <td>{{ item.HoldPeriod ? item.HoldPeriod + '天' : '--' }}</td>
                <td :class="[judgeColor(item.AvgSectionRate)]">
                  {{ toFixedNum(item.AvgSectionRate * 100, 2, '%') }}
                </td>
                <td>{{ toFixedNum(item.ProfitLossRatio, 2) }}</td>
                <td>{{ toFixedNum(item.RiseProbability * 100, 2, '%') }}</td>
              </tr>
            </table>
            <van-empty v-else class="custom-image" :image="not_data" description="暂未获取到数据" />
          </div>
          <!-- 收益分析 -->
          <div class="sy_main" v-show="hcSyTabId === 1">
            <div class="cont_main">
              <div class="selice_main">
                <div class="left_btn_main">
                  <span :class="syNavId === 0 ? 'active' : ''" @click="checkSyId(0)"
                    >历史累计收益图</span
                  >
                  <span :class="syNavId === 1 ? 'active' : ''" @click="checkSyId(1)">专业评级</span>
                </div>
              </div>
              <!-- 图表 -->
              <div class="tab_cont_box" v-show="syNavId === 0 && defaultQuery && chartData">
                <span>超参寻优策略</span>
                <span>沪深300</span>
              </div>
              <div
                class="line_box"
                id="chartLine"
                v-show="syNavId === 0 && defaultQuery && chartData"
              ></div>
              <div
                class="line_box"
                id="chartRadar"
                v-show="syNavId === 1 && defaultQuery && chartData"
              ></div>
              <van-empty
                v-if="
                  (syNavId === 0 && !chartData && defaultQuery && getIncomeanalysisQuery) ||
                  (syNavId === 1 && !chartData && defaultQuery && getIncomeanalysisQuery)
                "
                class="custom-image"
                :image="not_data"
                description="暂未获取到数据"
              />
              <div
                class="lhhcBtn"
                @click="gohcRait"
                v-if="
                  clCondition &&
                  clCondition.collection_type !== 1 &&
                  clCondition.collection_type !== 2 &&
                  clCondition.isCl &&
                  clCondition.type_info !== 2
                "
              >
                试试量化回测
              </div>
            </div>
          </div>
        </div>

        <p class="interval_box"></p>
        <!-- 历史明细 -->
        <div class="lsmx_box" id="lsmx">
          <div class="lsmxScorll_box" v-show="navId === 3">
            <!-- <div class="header_box">历史明细</div> -->
            <ul class="nav_box clearfix" v-if="hcfxData.length > 0 && defaultQuery && lsmxTimeShow">
              <li
                v-for="(item, index) in hcfxData"
                :key="index"
                :class="index === lsId ? 'active' : ''"
                @click="setChartPie(index)"
              >
                {{ item.HoldPeriod }}天
              </li>
            </ul>
            <table width="100%" cellspacing="0" cellpadding="0" v-show="lsmxTabShow">
              <tr>
                <th>股票名称</th>
                <th>起点/结束时间</th>
                <th>起/止价</th>
                <th>区间涨跌幅</th>
              </tr>
            </table>
          </div>
          <div class="header_box">
            <span>历史明细</span>
            <span v-if="defaultQuery && hcfxData.length" @click="hderShow">
              <van-icon name="arrow-down" v-if="!headerDown" />
              <van-icon name="arrow-up" v-else />
            </span>
          </div>
          <ul class="nav_box clearfix" v-if="hcfxData.length > 0 && defaultQuery">
            <li
              v-for="(item, index) in hcfxData"
              :key="index"
              :class="index === lsId ? 'active' : ''"
              @click="setChartPie(index)"
            >
              {{ item.HoldPeriod }}天
            </li>
          </ul>
          <div class="lsmxChart" v-show="defaultQuery && hcfxData.length && headerDown">
            <div id="chartLs"></div>
            <ul class="right">
              <li v-for="(item, index) in pieExplain" :key="index">
                <p><i class="dot" :style="{ background: colorList[index] }"></i>{{ item.name }}</p>
                <p>
                  {{ toFixedNum(RiseFallMap[index] * 100, 2, '%') }}
                </p>
              </li>
            </ul>
          </div>
          <div class="table_main">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              v-if="historyQuery && historyList.length > 0"
            >
              <tr>
                <th>股票名称</th>
                <th>起点/结束时间</th>
                <th>起/止价</th>
                <th>区间涨跌幅</th>
              </tr>
              <tr v-for="(item, index) in historyList" :key="index" @click="gogufs(item.StockCode)">
                <td>
                  <p>{{ item.StockName }}</p>
                  <p>{{ removePrefix(item.StockCode) }}</p>
                </td>
                <td>
                  <p>{{ convertTime(item.StartDate) }}</p>
                  <p>{{ convertTime(item.EndDate) }}</p>
                </td>
                <td>
                  <p>{{ item.BuyPrice ? toFixedNum(item.BuyPrice, 2, '') : '--' }}</p>
                  <p>{{ item.SellPrice ? toFixedNum(item.SellPrice, 2, '') : '--' }}</p>
                </td>
                <td :class="[judgeColor(item.SectionRate)]">
                  {{ toFixedNum(item.SectionRate * 100, 2, '%') }}
                </td>
              </tr>
            </table>
            <van-empty v-else class="custom-image" :image="not_data" description="暂未获取到数据" />
          </div>
          <div class="more_btn" @click="moreHistory" v-show="historyListCont">查看更多</div>
        </div>
      </div>
      <van-empty v-else class="custom-image" :image="not_data" description="暂未获取到数据" />
    </div>
    <van-popup v-model="screenPopup" position="bottom" :overlay="true">
      <div class="popup_box">
        <div class="tit_box">筛选今日信号</div>
        <div class="type_tit">总市值</div>
        <div class="selice_content">
          <ul>
            <li
              :class="propUpId === item.type ? 'active' : ''"
              v-for="item in propupData"
              :key="item.type"
              @click="checkpropUpFn(item.type)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="fod_btn_box">
          <div class="close_box" @click="popUpCloseFn">取消</div>
          <div class="confirm_box" @click="popUpConfirmFn">确定</div>
        </div>
      </div>
    </van-popup>
    <van-dialog
      v-model="dialogShow"
      :message="'当前策略涉及到最新的因子池功能，在移动端暂未开放，请到PC端大智慧VIP的因子投研模块进行编辑'"
      className="dialog_box"
      confirmButtonText="我知道了"
      @confirm="dialogShow = false"
    >
    </van-dialog>
    <NotHd v-if="notHd && defaultQuery"></NotHd>
    <takeOut
      :show="takeShow"
      :name="takeName"
      :btnText="takeBtnName"
      type="ccxy"
      @cancelBasis="cancelBasis"
      @linkGo="linkGo"
    ></takeOut>
    <!-- vip弹窗 -->
    <vipInfo :show="vipShow"></vipInfo>
  </div>
</template>

<script>
import { factorArrCheckoutFun } from '@/utils/commonAPI';
import navigation from '@/components/navigation.vue';
import NotHd from '@/components/notHd/notHd.vue';
import takeOut from '@/components/notHd/TakeOut.vue';
import mixin from '@/mixins/index.js';
import { toFixedNum, judgeColor, formtTime,compareVersions } from '@/utils/format';
import vipInfo from '@/components/diaLog/vipInfo.vue';

import {
  getDyzClById,
  getIncomeanalysis,
  getDyzHistory,
  getFactorHq,
  getObjSort,
  insertStockByGroup,
  getMyZxStockInfo,
  reportBrowse,
  addMyFavor,
  delMyFavor,
  setShareById
} from '@/api/index.js';

import VueScrollTo from 'vue-scrollto';
export default {
  name: 'tacticsdetail',
  mixins: [mixin],
  components: {
    navigation,
    NotHd,
    takeOut,
    vipInfo
  },
  data() {
    return {
      not_data: require('../../assets/image/notData.png'),
      screenImg: require('../../assets/image/screen_img.png'),
      blockScreenImg: require('../../assets/image/blockImg/screen_img.png'),
      filterNum: 0,
      scrollTop: 300,
      mainScrollShow: false,

      s_id: '', //策略ID
      clCondition: null,
      num: 2,
      yzNameArr: [], //因子池数据
      navList: [
        { name: '评级报告', id: 'pjbg' },
        { name: '今日信号', id: 'jrxh' },
        { name: '回测分析', id: 'hcfx' },
        { name: '历史明细', id: 'lsmx' }
      ],
      navId: 0,
      pgbgData: null, //评估报告数据
      typeInfo: 0, //评级报告信号类型
      xhF_id_arr: 'null', //策略F_id_arr ID
      sySeliceShow: false,
      sySeliceList: ['近一周', '近一月', '近三月', '近一年'],
      sySeliceId: '0',
      // chartBox: null,
      hcfxData: [], //hcfx列表数据
      // 最大区间均涨幅index
      maxAvgSectionIndex: 0,
      // 最大上涨该概率index
      maxRiseProbabilityIndex: 0,
      pianChart: null,
      lsId: 0,
      pieExplain: [
        {
          name: '大于7.5%'
        },
        {
          name: '3.5%到7.5%'
        },
        {
          name: '0到3.5%'
        },
        {
          name: '-3.5%到0%'
        },
        {
          name: '-3.5%到-7.5%'
        },
        {
          name: '小于-7.5%'
        }
      ],
      colorList: [
        'rgba(255, 99, 99, 1)',
        'rgba(255, 99, 99, 0.6)',
        'rgba(255, 99, 99, 0.4)',
        'rgba(47, 200, 123, 0.4)',
        'rgba(47, 200, 123, 0.6)',
        'rgba(47, 200, 123, 1)'
      ],
      RiseFallMap: [],
      lineChart: null,
      radarChart: null,
      syNavId: 0, //
      chartData: null, //收益分析中图标数据
      historyList: [], //历史数据list
      userID: '',
      hashID: '',
      historyStart: 0,
      historyListCont: false,

      hotTacticInterval: null, // 行情中定时器
      hqData: null, //行情数据

      xhList: [], //今日信号列表
      xhfield: 'ZhangFu',
      xhdesc: true,
      xhstart: 0,
      xhcount: 20,
      xhObjCount: 0,
      xhQuery: false,

      jrxhNavShow: false, //
      lsmxTabShow: false,
      lsmxTimeShow: false,

      sourceType: '', //页面来源

      myStockList: [],
      defaultQuery: false,
      historyQuery: false,

      allNotData: false,
      notHd: true, //没有慧豆

      headerDown: true,
      screenPopup: false,
      propupData: [
        { name: '全部', type: '' },
        { name: '≤50亿', type: 1 },
        { name: '50亿-100亿', type: 2 },
        { name: '100亿-500亿', type: 3 },
        { name: '500亿-1000亿', type: 4 },
        { name: '≥1000亿', type: 5 }
      ],
      propUpId: '',
      screenPopupId: '',
      themeStyleVs: 1,

      dialogShow: false,

      hcSyTab: ['回测分析', '参考收益分析'],
      hcSyTabId: 0,
      getIncomeanalysisQuery: false,
      takeShow: false,
      takeName: '',
      takeBtnName: '',
      // VIP标志
      isVip: false,
      vipShow: false,
      vipIcon: true
    };
  },
  filters: {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  created() {
    this.$store.commit('resetPublicHcID');
    this.$store.commit('resetObj');
    this.$store.commit('resetCheckedYzList');
    this.$store.commit('resetType');

    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
    let u = navigator.userAgent;
    if (
      typeof DzhAppJs !== 'undefined' &&
      u.indexOf('iPhone') > -1 && !compareVersions(this.getUrlQuery('version'),9.65)
    ) {
      let obj = { navBarHidden: 1, titleHidden: 1 };
      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('setTitleStyle', JSON.stringify(obj), '');
    }
  },
  mounted() {
    this.s_id = this.getUrlQuery('s_id');
    this.sourceType = this.getUrlQuery('type') ? this.getUrlQuery('type') : '';
    this.$nextTick(function () {
      // 判断是否展示vip
      if (compareVersions(this.$route.query.version , 9.71)) {
        this.vipIcon = true;
      } else {
        this.vipIcon = false;
      }

      this.getDetailData();
    });
    window.addEventListener('scroll', this.allPageScroll, true);
    this.$toast.loading({
      message: '加载中...',
      overlay: true,
      duration: 0
    });
  },
  methods: {
    toFixedNum,
    judgeColor,
    formtTime,
    compareVersions,
    // 请求多因子策略详情数据
    getDetailData: function () {
      let _this = this;
      let obj = {
        s_id: _this.s_id,
        type: _this.sourceType
      };
      getDyzClById(obj)
        .then((res) => {
          _this.defaultQuery = true;
          if (res.err === 200) {
            _this.clCondition = res.data.condition;
            _this.xhF_id_arr = res.data.condition.f_id_arr;
            let yzcName = res.data.condition.f_name_arr.split(',');
            let yzcId = res.data.condition.f_id_arr.split(',');
            let yzcArr = yzcName.map((item, index) => {
              return {
                name: item,
                id: yzcId[index]
              };
            });
            _this.yzNameArr = yzcArr;
            _this.pgbgData = res.data.ReportGradeResult;
            _this.checkXh(res.data.ReportGradeResult);
            _this.backtestData(res.data.BacktestAnalysisResult);
            // _this.getEarnings(res.data.condition.creator);
            _this.userID = res.data.condition.creator;
            _this.hashID = res.data.HashID;
            _this.getHistoryList();
            let idKeys = res.data.condition.f_id_arr.replaceAll(',', '_');
            _this.getHqData(idKeys);
            // _this.hotTacticInterval = window.setInterval(() => {
            //   _this.getHqData(idKeys);
            // }, 60000);
            _this.getMyOptional(res.data.condition.f_id_arr);

            _this.$nextTick(function () {
              _this.scrollTop = document.getElementById('hdMain').offsetHeight;
            });

            //以下数据用来去编辑的数据
            _this.vuexID = res.data.condition.s_id;
            _this.$store.commit('setPublicHcID', _this.vuexID);
            if (!res.data.condition.isCl) {
              _this.upReport(res.data.condition.s_id);
            }
          }
          _this.$toast.clear();
          if (res.err == 304) {
            _this.notHd = true;
            window.location.href = window.config.hdTips;
          } else {
            _this.notHd = false;
          }
          if (res.err === 301) {
            _this.allNotData = true;
            _this.$toast(res.msg);
          }
          if (res.err === 305) {
            _this.allNotData = true;
            _this.$toast('功能使用异常，请检查您的登录状态');
          }
          // 上报神策
          _this.reportShence();
        })
        .catch((err) => {
          _this.defaultQuery = true;
          _this.$toast.clear();
        });
    },
    // 上报数据
    upReport: function (id) {
      reportBrowse({ id: id, type: 2 }).then((res) => {});
    },
    // 获取行情数据
    getHqData: function (idKeys, data) {
      let that = this;
      let obj = {
        type: 'cl',
        groupID: idKeys
        // field: 'Desc'
      };
      getFactorHq(obj).then((res) => {
        if (res.err === 200) {
          that.hqData = res.data[0];
        }
      });
    },
    // 评级报告信号判断
    checkXh: function (obj) {
      let that = this;
      if (obj.MaxRiseRate * 100 > 55 && obj.BestAvgRate * 100 > 1) {
        that.typeInfo = 1;
      } else if (obj.MaxRiseRate * 100 < 45 && obj.BestAvgRate * 100 < 1) {
        that.typeInfo = 2;
      } else {
        that.typeInfo = 3;
      }
    },

    // 今日信号
    getXhData: function (id, addType) {
      let that = this;
      this.xhQuery = false;
      let obj = {
        factorid: id,
        field: that.xhfield,
        desc: that.xhdesc,
        start: that.xhstart,
        count: that.xhcount,
        filterate: that.propUpId
      };
      getObjSort(obj)
        .then((res) => {
          that.screenPopupId = that.propUpId;
          if (res.err === 200 && res.data.list.length > 0) {
            that.xhObjCount = res.data.ObjCount;
            if (addType) {
              that.xhList = that.checkStock(res.data.list);
            } else {
              that.xhList = [...that.xhList, ...that.checkStock(res.data.list)];
            }
          }
          that.xhQuery = true;
        })
        .catch(() => {
          that.xhQuery = true;
        });
    },
    // checkpropUpFn(item.type)
    checkpropUpFn: function (type) {
      let that = this;
      that.propUpId = type;
    },
    popUpCloseFn: function () {
      let that = this;
      that.screenPopup = false;
      that.propUpId = that.screenPopupId;
    },
    popUpConfirmFn: function () {
      let id = this.xhF_id_arr;
      this.xhQuery = false;
      this.xhstart = 0;
      this.xhList = [];
      this.getMyOptional(id);
      this.screenPopup = false;
    },
    // 获取我的自选股
    getMyOptional: function (f_id_arr) {
      let that = this;
      getMyZxStockInfo({})
        .then((res) => {
          if (res.err === 200) {
            that.myStockList = res.data.Stocks ? res.data.Stocks : [];
            that.$nextTick(function () {
              that.getXhData(f_id_arr, true);
            });
          } else {
            that.xhQuery = true;
          }
        })
        .catch(() => {
          that.xhQuery = true;
        });
    },
    // 处理自选数据判断当前股票是否已加入自选
    checkStock: function (arr) {
      let that = this;
      let stocks = that.myStockList.toString();
      let newArr = arr.map((item) => {
        if (stocks.indexOf(item.Obj) !== -1) {
          item.joinShow = true;
        } else {
          item.joinShow = false;
        }
        return item;
      });
      return newArr;
    },
    // 今日信号点击更多
    jrxhMore: function () {
      this.xhstart = this.xhstart + 20;
      this.getXhData(this.xhF_id_arr, false);
    },
    // 今日信号排序
    sortFn: function (type) {
      // this.
      if (this.xhfield === type) {
        this.xhdesc = !this.xhdesc;
      } else {
        this.xhfield = type;
        this.xhdesc = true;
      }
      this.xhstart = 0;
      // this.xhList = [];
      this.getXhData(this.xhF_id_arr, true);
    },

    // 加自选
    addStock: function (item, index) {
      if (item.joinShow) return;
      let obj = {
        stocks: item.Obj
      };
      insertStockByGroup(obj).then((res) => {
        if (res.err === 200) {
          let ste = this.xhList[index];
          this.$set(ste, 'joinShow', true);
          this.$toast('加入成功');
        } else {
          this.$toast('加入失败');
        }
      });
    },
    // 处理回测分析中数据
    backtestData: function (data) {
      let that = this;
      that.hcfxData = data;
      // 获取AvgSectionRate (平均区间最大涨幅)
      const arrAvgSectionRate = data.map(({ AvgSectionRate }) => AvgSectionRate);
      const maxAvgSectionRate = that.getMax(arrAvgSectionRate);
      const maxAvgSectionIndex = arrAvgSectionRate.indexOf(maxAvgSectionRate); // 获取最大值在数组中的索引位置
      that.maxAvgSectionIndex = maxAvgSectionIndex;
      that.lsId = maxAvgSectionIndex;

      // 获取RiseProbability (最大上涨概率)
      const arrRiseProbability = data.map(({ RiseProbability }) => RiseProbability);
      const maxRiseProbability = that.getMax(arrRiseProbability);
      const maxRiseProbabilityIndex = arrRiseProbability.indexOf(maxRiseProbability); // 获取最大值在数组中的索引位置
      that.maxRiseProbabilityIndex = maxRiseProbabilityIndex;
      that.$nextTick(function () {
        that.chartFn();
      });
    },
    setChartPie: function (index) {
      let that = this;
      that.lsId = index;
      that.historyStart = 0;
      that.$nextTick(function () {
        that.chartFn();
        that.getHistoryList(false);
      });
    },
    checkDivisor: function () {
      if (this.num === 2) {
        this.num = this.yzNameArr.length;
      } else {
        this.num = 2;
      }
      this.$nextTick(function () {
        this.scrollTop = document.getElementById('hdMain').offsetHeight;
      });
    },
    scrollToSection(sectionId) {
      let offsetHeight =
        document.querySelector('.navg_box').offsetHeight +
        document.querySelector('.nav_list_main').offsetHeight;
      VueScrollTo.scrollTo(`#${sectionId}`, 100, {
        offset: -offsetHeight // 调整偏移量以适应您的布局
      });
    },
    checkNav: function (id, type) {
      this.navId = id;
      this.scrollToSection(type);
    },
    showSySelice: function () {
      this.sySeliceShow = !this.sySeliceShow;
    },
    // 创建折线图
    foundLine: function (lineData) {
      let that = this;
      if (!that.lineChart) {
        that.lineChart = this.$echarts.init(document.getElementById('chartLine'));
        window.addEventListener('resize', that.resizeHandler);
      }
      let option;
      option = {
        color: ['#286DF7', '#FF9153'],
        tooltip: {
          trigger: 'axis',
          extraCssText: 'z-index:2',
          confine: true,
          backgroundColor: that.$route.query.themeStyleVs == 2 ? '#181A23' : '#fff',
          borderColor: that.$route.query.themeStyleVs == 2 ? '#181A23' : '#fff', // 设置 Tooltip 的边框颜色
          textStyle: {
            // 设置 Tooltip 中文字的样式
            color: that.$route.query.themeStyleVs == 2 ? '#AAB9D1' : '' // 设置文字颜色
          },
          formatter: function (params) {
            let str;
            str = `<div class="tooltip">
			  <div class="date">${that.convertTime(params[0].axisValue)}</div>
			  <div class="item"><span style="width:10px;height:10px;background-color:${
          params[0].color
        };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>历史累计收益：</span><em>${
              params[0].value + '%'
            }</em></div>
			  <div class="item"><span style="width:10px;height:10px;background-color:${
          params[1].color
        };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>沪深300：</span><em>${
              params[1].value + '%'
            }</em></div>
			  </div>`;
            return str;
          }
        },
        grid: {
          left: 0,
          right: 3,
          bottom: 10,
          top: 10,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: lineData.xAxis,
          axisTick: { show: false },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: that.themeStyleVs === 2 ? '#6B7687' : '#999',
            show: true,
            interval: 10000,
            showMinLabel: true,
            showMaxLabel: true,
            formatter: function (value) {
              //文本格式化
              if (value === lineData.xAxis[0]) {
                return '{right|' + that.convertTime(value) + '}';
              } else if (value === lineData.xAxis[lineData.xAxis.length - 1]) {
                return '{left|' + that.convertTime(value) + '}';
              } else {
                return '{center|' + that.convertTime(value) + '}';
              }
            },
            rich: {
              right: {
                width: 50,
                fontSize: 10,
                align: 'left',
                padding: [0, 0, 0, 50]
              },
              left: {
                width: 50,
                fontSize: 10,
                align: 'left',
                padding: [0, 50, 0, 0]
              },
              center: {
                fontSize: 10,
                align: 'left'
              }
            }
          }
        },
        yAxis: {
          type: 'value',
          position: 'left',
          axisTick: { show: false },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: that.themeStyleVs === 2 ? '#6B7687' : '#999',
            show: true,
            formatter: function (val) {
              return val + '%';
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: that.themeStyleVs === 2 ? '#6B7687' : '#e5e5e5'
            }
          }
        },
        series: [
          {
            data: lineData.dayData,
            type: 'line',
            symbol: 'none',
            smooth: true,
            areaStyle: {
              // color:['rgba(40, 109, 247, 0.2)','rgba(40, 109, 247, 0)']
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(58,132,255, 0.5)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            data: lineData.hsData,
            type: 'line',
            symbol: 'none',
            smooth: true,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(247, 152, 40, 0.5)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(247, 152, 40, 0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      };

      option && that.lineChart.setOption(option);
    },
    resizeHandler: function () {
      if (this.lineChart) {
        this.lineChart.resize();
      }
      if (this.pianChart) {
        this.pianChart.resize();
      }
      if (this.radarChart) {
        this.radarChart.resize();
      }
    },
    // pain
    chartFn: function () {
      let that = this;
      if (!that.pianChart && that.hcfxData) {
        that.pianChart = that.$echarts.init(document.getElementById('chartLs'));
        window.addEventListener('resize', that.resizeHandler);
      }
      let data = that.hcfxData[that.lsId].RiseFallMap;
      data = data.slice(1);
      data = data.slice(0, -1);
      data = data.split(',');
      that.RiseFallMap = data;
      let option = {
        series: [
          {
            type: 'pie',
            radius: '80%',
            color: that.colorList,
            data: data,
            emphasis: {
              scale: false // 禁止点击放大效果
            },
            label: {
              show: false // 隐藏坐标值
            }
          }
        ]
      };
      option && that.pianChart.setOption(option);
    },
    // 雷达图
    foundRadar: function (data) {
      let that = this;
      if (!that.radarChart) {
        that.radarChart = that.$echarts.init(document.getElementById('chartRadar'));
        window.addEventListener('resize', that.resizeHandler);
      }
      let maxNum = that.getMax(Object.values(data));
      let option;
      option = {
        radar: {
          center: ['50%', '50%'],
          radius: '70%',
          indicator: [
            { name: '盈利能力', max: 100 },
            { name: '选股能力', max: 100 },
            { name: '抗风险能力', max: 100 },
            { name: '稳定性', max: 100 },
            { name: '绝对收益', max: 100 }
          ],
          splitArea: {
            areaStyle: {
              color: that.themeStyleVs === 2 ? ['#181A23'] : ['#FFF']
            }
          },
          axisLine: {
            lineStyle: {
              color: that.themeStyleVs === 2 ? '#AAB9D1' : 'rgba(102, 102, 102, 0.90)'
            }
          },
          splitLine: {
            lineStyle: {
              color: that.themeStyleVs === 2 ? '#AAB9D1' : 'rgba(102, 102, 102, 0.90)'
            }
          }
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: that.$route.query.themeStyleVs == 2 ? '#181A23' : '#fff',
          borderColor: that.$route.query.themeStyleVs == 2 ? '#181A23' : '#fff', // 设置 Tooltip 的边框颜色
          textStyle: {
            // 设置 Tooltip 中文字的样式
            color: that.$route.query.themeStyleVs == 2 ? '#AAB9D1' : '' // 设置文字颜色
          }
        },
        series: [
          {
            type: 'radar',
            name: '专业评级',
            data: [
              {
                value: [
                  data.ProfitAbility,
                  data.StockAbility,
                  data.AntiRiskAbility,
                  data.Stability,
                  data.AbsIncome
                ],
                //
                areaStyle: {
                  color:
                    that.themeStyleVs === 2 ? 'rgba(59, 133, 254, 1)' : 'rgba(40, 109, 247, .5)'
                },
                symbol: 'none'
              }
            ]
          }
        ]
      };

      option && that.radarChart.setOption(option);
    },
    // 根据条件获取多因子策略参考收益分析
    getEarnings: function (userId) {
      let that = this;
      let obj = {
        userid: userId,
        factorlist: that.xhF_id_arr,
        s_id: that.clCondition.s_id,
        startdate: this.formtTime(this.getLastYear(), 'yyyyMMdd'),
        enddate: this.formtTime(this.getLastDay(), 'yyyyMMdd')
      };
      getIncomeanalysis(obj)
        .then((res) => {
          if (res.err === 200) {
            that.foundLine(res.data.lineData);
            that.chartData = res.data;
          }
          if (res.err == 304) {
            window.location.href = window.config.hdTips;
          }
          that.getIncomeanalysisQuery = true;
        })
        .catch(() => {
          that.getIncomeanalysisQuery = true;
        });
    },
    // 点击切换收益分析中的navId
    checkSyId: function (id) {
      let that = this;
      that.syNavId = id;
      if (id === 0) {
        if (that.chartData && that.chartData.lineData) {
          that.foundLine(that.chartData.lineData);
        }
      } else {
        if (that.chartData && that.chartData.RadarMapResult) {
          that.foundRadar(that.chartData.RadarMapResult);
        }
      }
    },
    // 历史明细中列表数据
    getHistoryList: function (type) {
      let that = this;
      let obj = {
        userID: that.userID,
        hashID: that.hashID,
        startDate: that.formtTime(that.getLastYear(), 'yyyyMMdd'),
        endDate: that.formtTime(that.getLastDay(), 'yyyyMMdd'),
        holdPeriod: that.hcfxData[that.lsId].HoldPeriod,
        start: that.historyStart,
        count: 10
      };
      getDyzHistory(obj)
        .then((res) => {
          that.historyQuery = true;
          if (res.err === 200) {
            that.historyListCont = true;
            if (res.data.length > 0) {
              if (type) {
                that.historyList = [...that.historyList, ...res.data];
              } else {
                that.historyList = res.data;
              }
            } else {
              this.historyListCont = false;
            }
          }
        })
        .then(() => {
          that.historyQuery = true;
        });
    },
    // 查看更多历史数据
    moreHistory: function () {
      let that = this;
      that.historyStart = that.historyStart + 10;
      that.$nextTick(function () {
        that.getHistoryList(true);
      });
    },
    //全屏滚动
    allPageScroll: function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let jrxh = document.querySelector('#jrxh').offsetTop;
      let hcfx = document.querySelector('#hcfx').offsetTop;
      let lsmx = document.querySelector('#lsmx').offsetTop;
      // let syfx = document.querySelector('#syfx').offsetTop;
      let navHeight = document.querySelector('.nav_list_main').offsetHeight;
      let topHeight = document.querySelector('#hdMain').offsetHeight;
      let navgBoxH = document.querySelector('.navg_box').offsetHeight;
      let contantMainTop = document.querySelector('.contant_main').offsetTop;

      let tit_main_height = document.querySelector('#tit_main_height').offsetHeight;
      this.filterNum = (scrollTop / (contantMainTop / 6)).toFixed(2);
      if (scrollTop >= topHeight - navgBoxH) {
        this.mainScrollShow = true;
      } else {
        this.mainScrollShow = false;
      }
      if (scrollTop >= jrxh - navHeight - navgBoxH && scrollTop < hcfx - navHeight - navgBoxH) {
        this.navId = 1;
        if (
          scrollTop >= jrxh - navHeight - navgBoxH + tit_main_height &&
          scrollTop < hcfx - navgBoxH - navHeight - 20
        ) {
          this.jrxhNavShow = true;
        } else {
          this.jrxhNavShow = false;
        }
      } else if (
        scrollTop >= hcfx - navHeight - navgBoxH &&
        scrollTop < lsmx - navHeight - navgBoxH
      ) {
        this.navId = 2;
      } else if (scrollTop >= lsmx - navHeight - navgBoxH - tit_main_height) {
        this.navId = 3;
        if (scrollTop >= lsmx - navHeight - navgBoxH + tit_main_height) {
          this.lsmxTimeShow = true;
        } else {
          this.lsmxTimeShow = false;
        }
        if (
          scrollTop >=
          lsmx -
            navHeight -
            navgBoxH +
            tit_main_height +
            document.querySelector('.lsmxChart').offsetHeight
        ) {
          this.lsmxTabShow = true;
        } else {
          this.lsmxTabShow = false;
        }
      } else if (scrollTop < jrxh - navHeight - navgBoxH) {
        this.navId = 0;
      }
    },
    //跳转编辑
    goEdit: function async() {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
        return false;
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        // this.vipShow = true;
        // 调用客户端js 弹窗
        // 编辑多因子策略
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0707',
          sourcecode: '3509',
          mediaID: '0707'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
        return false;
      }

      var ctype;

      if (
        this.clCondition.collection_condition &&
        this.clCondition.collection_condition != 'null'
      ) {
        ctype = JSON.parse(this.clCondition.collection_condition);
      }

      if (!this.clCondition.collection_condition && !this.clCondition.collection_type) {
        this.getFactorHqFun(this.clCondition.f_id_arr);
      } else {
        if (
          ctype.composeType == 'bj' ||
          ctype.children.length ||
          this.clCondition.collection_type == 4 ||
          !this.clCondition.collection_condition ||
          this.clCondition.collection_condition == 'null'
        ) {
          this.$dialog
            .alert({
              onfirmButtonText: '我知道了',
              message:
                '当前策略涉及到最新的因子池功能，在移动端暂未开放，请到PC端大智慧VIP的因子投研模块进行编辑'
            })
            .then(() => {});

          return false;
        } else {
          // 提取 "yzList" 和 "children" 下的每一项
          var yzListItems = ctype.yzList;
          var childrenItems = [];

          // 提取 "children" 中的每个子数组中的子项
          if (ctype.children) {
            ctype.children.forEach(function (childArray) {
              childrenItems = childrenItems.concat(childArray);
            });
          }

          // 合并 "yzList" 和 "children" 中的所有项到一个新数组
          var combinedArray = yzListItems.concat(childrenItems);

          this.$store.commit('setCheckedYzList', combinedArray);
        }
      }

      let msg = [];
      factorArrCheckoutFun(this.clCondition.f_id_arr).then((d) => {
        if (d.length > 0) {
          d.forEach((i) => {
            if (i.BacktestType == 2 || i.BacktestType == 3) {
              msg.push(i.Name + '(不可回测)');
            } else if (i.BacktestType == 10) {
              msg.push(i.Name + '(已删除)');
            }
          });

          this.$toast('编辑参数失败:' + msg.toString());
        } else {
          var vuexObj = {
            holdPeriodList: this.clCondition.s_chigu_cycle,
            isCustomSelected: this.clCondition.s_chigu_type === 1 ? true : false, //持股类型 : 0默认 1自定义 2固定
            yzIds: this.clCondition.f_id_arr, //因子id
            name: this.clCondition.s_name, //策略名称
            desc: this.clCondition.s_desc, //策略描述
            type_info: this.clCondition.type_info, //因子类型 1A股 2etf
            isEdit: true
          };

          this.$store.commit('setType', 'source_dyzclDetails'); //标记是从策略详情过去的
          this.$store.commit('setObj', vuexObj);

          this.$router.push({
            path: '/checkedYz',
            name: 'CheckedYz',
            query: {
              source: 'dyzcl', //用来标注是从多因子还是量化过去的
              token: this.$route.query.token || '',
              mySource: 'myCl', //编辑从我的-策略跳转过去的
              themeStyleVs: this.$route.query.themeStyleVs || 0,
              version: this.getUrlQuery('version'),
              yzType: this.clCondition.type_info == 2 ? 'ETF' : 'A'
            }
          });
        }
      });
    },
    //行情
    getFactorHqFun: function (yzIds) {
      var params = {
        type: 'yz',
        factorID: yzIds,
        field: 'Desc,KanDian,FactorCode,XiFenZhongLei'
      };
      return getFactorHq(params)
        .then((res) => {
          this.$store.commit('setCheckedYzList', res.data);
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    // 跳转量化回测
    gohcRait: function () {
      let msg = [];
      factorArrCheckoutFun(this.clCondition.f_id_arr).then((d) => {
        if (d.length > 0) {
          d.forEach((i) => {
            if (i.BacktestType == 2 || i.BacktestType == 3) {
              msg.push(i.Name + '(不可回测)');
            } else if (i.BacktestType == 10) {
              msg.push(i.Name + '(已删除)');
            }
          });

          this.$toast('发起回测失败:' + msg.toString());
        } else {
          this.$store.commit('resetObj');
          // this.$store.commit('resetCheckedYzList');
          this.$store.commit('setPublicHcID', null);
          var vuexObj = {
            holdPeriodList: this.clCondition.s_chigu_cycle,
            isCustomSelected: this.clCondition.s_chigu_type === 1 ? true : false, //持股类型 : 0默认 1自定义 2固定
            yzIds: this.clCondition.f_id_arr, //因子id
            sortDirection: this.chartData.BestParamResult.SortDirection, //买入顺序方向 0:小大到小  1:从小到大
            sortKind: this.chartData.BestParamResult.SortKind, //买入顺序0~7  0:成交额 1:涨跌幅 2:换手率 3:量比 4:总市值 5:流通市值 6:市盈率TTM 7:振幅
            startMoney: this.chartData.BestParamResult.StartMoney, //初始资金 单位:元
            stopLoss: this.chartData.BestParamResult.StopLossRate, //止损条件
            stopProfitHigh: this.chartData.BestParamResult.StopProfitHigh, //止盈上限
            stopProfitLow: this.chartData.BestParamResult.StopProfitLow, //止盈下限
            buyLimit: this.chartData.BestParamResult.BuyLimit, //单日买入上限， 单位:支
            PositionLimit: this.chartData.BestParamResult.PosLimit //持仓上限， 单位:支
          };

          this.$store.commit('setObj', vuexObj);
          this.$store.commit('setType', 'source_dyzclDetails'); //标记是从策略详情过去的

          if (
            this.clCondition.collection_condition &&
            this.clCondition.collection_condition != 'null' &&
            this.clCondition.collection_type != 4
          ) {
            var jsonData = JSON.parse(this.clCondition.collection_condition);

            // 提取 "yzList" 和 "children" 下的每一项
            var yzListItems = jsonData.yzList;
            var childrenItems = [];

            // 提取 "children" 中的每个子数组中的子项
            if (jsonData.children) {
              jsonData.children.forEach(function (childArray) {
                childrenItems = childrenItems.concat(childArray);
              });
            }

            // 合并 "yzList" 和 "children" 中的所有项到一个新数组
            var combinedArray = yzListItems.concat(childrenItems);

            this.$store.commit('setCheckedYzList', combinedArray);
          } else {
            let a = this.clCondition.f_name_arr.split(',');
            let b = [];
            a.forEach((i, index) => {
              b[index] = {
                FactorName: i
              };
            });

            if (this.clCondition.collection_type == 4) {
              this.$store.commit('setCheckedYzList', b);
            } else {
              this.getFactorHqFun(this.clCondition.f_id_arr);
            }
          }

          this.$router.push({
            path: '/checkedYz',
            name: 'CheckedYz',
            query: {
              source: 'lhcl', //用来标注是从多因子还是量化过去的
              token: this.$route.query.token || '',
              type: 'add',
              themeStyleVs: this.$route.query.themeStyleVs || 0,
              version: this.getUrlQuery('version'),
              yzType: this.clCondition.type_info == 2 ? 'ETF' : 'A',
              createType: 'sslh'
            }
          });
        }
      });
    },
    // 关注
    gzFn: function () {
      let that = this;
      let obj = {
        type: 1,
        id: that.clCondition.s_id,
        s_name: that.clCondition.s_name,
        f_id_arr: that.clCondition.f_id_arr,
        creator: that.clCondition.creator
      };
      addMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.clCondition.isGz = true;
          that.$toast('关注成功');
        }
      });
    },
    // 取消关注
    delGz: function () {
      let that = this;
      let obj = {
        type: 1,
        id: that.clCondition.s_id
      };
      delMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.clCondition.isGz = false;
          that.$toast('取消成功');
        }
      });
    },
    hderShow: function () {
      this.headerDown = !this.headerDown;
      this.$nextTick(function () {
        if (this.headerDown) {
          this.chartFn();
        }
      });
    },
    // 点击显示今日信号选择框
    screenPopupShow: function () {
      this.screenPopup = true;
      this.propUpId = this.screenPopupId;
    },
    // 点击切换回测分析以及参考收益分析
    checkHcSy: function (index) {
      let that = this;
      if (index === 1) {
        // 判断是否是vip
        if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
        return false;
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
          // 如果不是VIP用户,弹出VIP提示
          // this.vipShow = true;
          // 调用客户端js 弹窗
          // 多因子超参寻优-JSON
          let appJson = {
            channel: 'yinzi',
            dzhadid: '0708',
            sourcecode: '3509',
            mediaID: '0708'
          };
          DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
            'factorNoVipPerDialog',
            JSON.stringify(appJson),
            ''
          );
          return false;
        }
        if (that.clCondition.isCl) {
          // if (localStorage.getItem('ccxy') === 'true') {
          if (!that.chartData && !that.getIncomeanalysisQuery) {
            that.getEarnings(that.userID);
          }
          that.hcSyTabId = index;
          // } else {
          //   that.takeName =
          //     '每次查看策略的参考收益分析需消耗 5个慧豆，且今日内查看相同策略的参考收益不会重复扣豆';
          //   that.takeBtnName = '继续查看';
          //   that.takeShow = true;
          // }
        } else {
          if (!that.chartData && !that.getIncomeanalysisQuery) {
            that.getEarnings(that.userID);
          }
          that.hcSyTabId = index;
        }
      } else {
        that.hcSyTabId = index;
      }
    },
    cancelBasis: function (e) {
      this.takeShow = e;
    },
    linkGo: function () {
      let that = this;
      if (!that.chartData && !that.getIncomeanalysisQuery) {
        that.getEarnings(that.userID);
      }
      that.hcSyTabId = 1;
      that.cancelBasis(false);
    },

    shareBtn: function () {
      let that = this;
      setShareById({}).then((res) => {
        if (res.err === 200) {
          let obj = {
            id: that.s_id,
            type: 2,
            sid: res.data
          };
          let urlLink = encodeURIComponent(
            window.config.shareLink + '?DZHSPECIAL=256&sid=' + res.data + '&type=2&id=' + that.s_id
          );
          if (/android/i.test(navigator.userAgent)) {
            urlLink = encodeURIComponent(urlLink);
          }
          window.location.href =
            'dzh_browser_url&goto=0&screen=470&title=我在大智慧因子投研平台发现了一个策略，一起来看看吧！&text=因子投研平台&url=' +
            urlLink +
            '&icon=' +
            window.config.shareLogo +
            '&ext=' +
            JSON.stringify(obj);
        }
      });
    },
    // 上报神策
    reportShence: function () {
      console.log('reportShence');
      console.log('this.clCondition', this.clCondition);
      if (
        this.clCondition.collection_condition &&
        this.clCondition.collection_condition !== null &&
        this.clCondition.collection_condition !== 'null'
      ) {
        let jsonArray = JSON.parse(this.clCondition.collection_condition);
        // 判断 yzList 是否为空
        if (jsonArray.yzList.length > 0) {
          jsonArray.yzList.forEach((element) => {
            // 如果是普通因子就上报
            if (element.yzType == 0) {
              console.log('上报成功', {
                factor_id: element.ID,
                operate_type: 'back_test',
                platform: 'Web-App'
              });
              sensors.track('factor_click', {
                factor_id: element.ID,
                operate_type: 'back_test',
                platform: 'Web-App'
              });
            }
          });
        }
        // 判断 children 是否为空
        if (jsonArray.children.length > 0) {
          jsonArray.children.forEach((element) => {
            element.forEach((element2) => {
              console.log('上报成功', {
                factor_id: element2.ID,
                operate_type: 'back_test',
                platform: 'Web-App'
              });
              sensors.track('factor_click', {
                factor_id: element2.ID,
                operate_type: 'back_test',
                platform: 'Web-App'
              });
            });
          });
        }
      }
    }
  },
  beforeDestroy() {
    // window.clearInterval(that.hotTacticInterval);
    // that.hotTacticInterval = null;
    window.removeEventListener('scroll', this.allPageScroll, true);
    window.removeEventListener('resize', this.resizeHandler);
  }
};
</script>
<style lang="less" scoped>
.hot_page {
  width: 100%;
  height: 100%;
  .sticky_header {
    .navg_box {
      background: linear-gradient(198.51deg, #4478ff -5%, rgba(239, 242, 250, 1) 95%);
      padding-top: 0;
      .bg_box {
        width: 100%;
        height: 100%;
        padding-top: 44px;
        background: url('../../assets/image/detail_top.png') top no-repeat;
        background-size: 100% 170px;
      }
    }
  }
  .navg_box {
    width: 100%;
    padding-top: 0px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    .bg_box {
      padding-top: 44px;
    }
  }
  header {
    width: 100%;
    background: linear-gradient(198.51deg, #4478ff -6.42%, rgba(239, 242, 250, 0.4) 83.87%);
    .header_main {
      padding-top: 88px;
      background: url(../../assets/image/detail_top.png) no-repeat;
      background-size: 56vh;
    }
    .hd_main {
      padding: 0 16px;
      box-sizing: border-box;
      padding-bottom: 24px;
      .cl_tit_main {
        width: 100%;
        height: 46px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .text {
          font-size: 20px;
          font-weight: bold;
          color: #373a4d;
        }
        .btn {
          width: 60px;
          height: 30px;
          background: #286df7;
          border-radius: 4px;
          line-height: 30px;
          text-align: center;
          color: #fff;
        }
      }
      .introduce_box {
        padding: 4px 0;
        font-size: 12px;
        color: #666666;
      }
      .msg_main {
        width: 100%;
        margin-bottom: 8px;
        background-color: #fff;
        border: 1px solid #ffffff;
        border-radius: 4px;
        ul {
          width: 100%;
          li {
            width: 33.33333333333333%;
            text-align: center;
            padding: 10px 0 12px 0;
            box-sizing: border-box;
            float: left;
            &:nth-child(1),
            &:nth-child(2) {
              position: relative;
              &::before {
                content: ' ';
                position: absolute;
                top: 50%;
                right: 0;
                transform: translate(0, -50%);
                width: 1px;
                height: 10px;
                background: rgba(153, 153, 153, 0.2);
              }
            }
            p {
              &:first-child {
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: #373a4d;
              }
              &:last-child {
                font-size: 12px;
                color: #666666;
              }
            }
          }
        }
      }
      .divisor_main {
        .tit_box {
          font-weight: 700;
          font-size: 14px;
          color: #286df7;
          margin-bottom: 6px;
        }
        .yzc_list {
          .li {
            height: 34px;
            line-height: 34px;
            border: 1px solid #fff;
            border-radius: 4px;
            background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
            padding: 0 12px;
            margin-top: 6px;
            font-weight: 500;
            font-size: 12px;
            color: rgba(55, 58, 77, 0.9);
          }
        }
      }
    }
  }
  .contant_main {
    width: 100%;
    overflow: hidden;
    background: #fff;
    padding-top: 6px;
    background: linear-gradient(0deg, #4478ff -10%, #eff2fa -119%);
    .main_all {
      border-radius: 8px 8px 0px 0px;
      overflow: hidden;
      background-color: #fff;
      // background:inear-gradient(198.51deg, #4478ff -5%, rgba(239, 242, 250, 1) 95%);
      .nav_list_main {
        width: 100%;
        height: 36px;
        padding: 0 12px;
        box-sizing: border-box;
        li {
          width: 25%;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          color: #373a4d;
          display: inline-block;
          &.active {
            position: relative;
            color: #286df7;
            font-weight: 600;
            &::before {
              content: ' ';
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translate(-50%, 0);
              width: 16px;
              height: 2px;
              border-radius: 4px;
              background: #286df7;
            }
          }
        }
      }
      .pj_main {
        padding: 16px;
        box-sizing: border-box;
        .tit_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 15px;
          p {
            font-weight: 600;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.9);
          }
          button {
            border-radius: 2px;
            font-weight: 400;
            font-size: 12px;
            color: #fff;
            padding: 2px 4px;
            &.tg2 {
              background: linear-gradient(270deg, #00701e 0%, #5db688 100%);
            }
            &.tg1 {
              background: linear-gradient(270deg, #cd0000 0%, #f76825 100%);
            }
            &.tg3 {
              background: linear-gradient(270deg, #3a497f 0%, #99a4ce 100%);
            }
          }
        }
        .intro_text {
          font-size: 14px;
          line-height: 22px;
          color: #373a4d;
          margin-bottom: 16px;
        }
        .xx_list {
          width: 100%;
          ul {
            width: 100%;
            li {
              width: 100%;
              display: flex;
              margin-bottom: 8px;
              &:last-child {
                margin-bottom: 0;
              }
              .left {
                width: 33.33333333%;
                text-align: left;
                font-size: 12px;
                line-height: 17px;
                color: #999999;
              }
              .right {
                width: 66.66666667%;
                text-align: right;
                font-size: 12px;
                line-height: 17px;
                color: #373a4d;
              }
            }
          }
        }
      }
      .interval_box {
        width: 100%;
        height: 8px;
        background-color: #f8f9fc;
      }
      .jrxh_box {
        width: 100%;

        .tit {
          width: 100%;
          padding: 16px;
          font-size: 16px;
          font-weight: 600;
          color: #373a4de5;
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 16px;
            height: 16px;
          }
        }
        .table_content {
          margin-bottom: 8px;
          table {
            th {
              font-size: 12px;
              color: #999999;
              font-weight: 400;
              padding: 4px 0;

              &:first-child {
                padding-left: 15px;
                box-sizing: border-box;
                text-align: left;
                width: 25%;
              }
              &:last-child {
                padding-right: 15px;
                box-sizing: border-box;
                text-align: right;
                width: 20%;
              }
            }
            td {
              height: 57px;
              text-align: center;
              font-size: 14px;
              color: #555555;
              &:first-child {
                padding-left: 15px;
                width: 25%;
                p {
                  text-align: left;
                  &:first-child {
                    color: #555555;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 20px;
                  }
                  &:last-child {
                    color: #999999;
                    font-size: 12px;
                    line-height: 17px;
                  }
                }
              }
              &:last-child {
                padding-right: 17px;
                width: 20%;
                font-size: 11px;
                span {
                  padding: 2px 3px;
                  background-color: rgba(40, 109, 247, 0.06);
                  color: #286df7;
                  border-radius: 2px;
                  float: right;
                  &.active {
                    background-color: rgba(153, 153, 153, 0.0588235);
                    color: #999999;
                  }
                }
              }
            }
          }
          .more_btn {
            width: 343px;
            height: 33px;
            text-align: center;
            line-height: 33px;
            background: rgba(40, 109, 247, 0.06);
            border-radius: 4px;
            color: #286df7;
            font-size: 12px;
            margin: 0 auto;
          }
        }
      }
      .hcsy_box {
        .tab_box {
          width: 100%;
          height: 36px;
          padding: 0 12px;
          ul {
            width: 100%;
            height: 100%;
            li {
              display: inline-block;
              line-height: 36px;
              font-size: 14px;
              color: #373a4d;
              padding: 0 16px;
              &.active {
                position: relative;
                color: #286df7;
                font-weight: 600;
                &::before {
                  content: ' ';
                  position: absolute;
                  left: 50%;
                  bottom: 0;
                  transform: translate(-50%, 0);
                  width: 16px;
                  height: 2px;
                  border-radius: 4px;
                  background: #286df7;
                }
              }
            }
          }
        }
      }
      .sy_main {
        width: 100%;
        .tit_box {
          width: 100%;
          padding: 8px 16px 4px 16px;
          font-size: 14px;
          color: #666666;
        }
        .cont_main {
          width: 100%;
          padding: 14px 0;
          .tab_cont_box {
            width: 100%;
            display: flex;
            align-items: center;
            padding-left: 50px;
            margin-bottom: 10px;
            span {
              color: #373a4d;
              font-size: 14px;
              line-height: 20px;
              &:first-child {
                margin-right: 38px;
                position: relative;
                &:before {
                  content: ' ';
                  position: absolute;
                  top: 8px;
                  left: -22px;
                  width: 16px;
                  height: 6px;
                  background: linear-gradient(
                    rgba(40, 109, 247, 1) 10%,
                    rgba(40, 109, 247, 0.2) 90%
                  );
                }
              }
              &:nth-child(2) {
                position: relative;
                margin-right: 38px;
                &:before {
                  content: ' ';
                  position: absolute;
                  top: 8px;
                  left: -22px;
                  width: 16px;
                  height: 6px;
                  background: linear-gradient(
                    rgba(255, 145, 83, 1) 10%,
                    rgba(247, 152, 40, 0.2) 90%
                  );
                }
              }
            }
          }
          .selice_main {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
            .left_btn_main {
              padding-left: 21px;
              span {
                display: inline-block;
                padding: 0 6px;
                height: 25px;
                border: 1px solid #f5f6f9;
                border-radius: 4px;
                text-align: center;
                line-height: 25px;
                font-size: 12px;
                color: #555555;
                &:first-child {
                  margin-right: 8px;
                }
                &.active {
                  background-color: rgba(40, 109, 247, 0.1);
                  color: #286df7;
                  font-weight: 500;
                }
              }
            }
            .right_selice {
              padding-right: 19px;
              position: relative;
              .selice_btn {
                padding: 2px 14px 2px 6px;
                box-sizing: border-box;
                background-color: #f5f6f9;
                border-radius: 6px;
                color: #373a4d;
                font-size: 12px;
                font-weight: 500;
                position: relative;
                &::before {
                  content: '';
                  position: absolute;
                  top: 9px;
                  right: 6px;
                  width: 0;
                  height: 0;
                  display: block;
                  border-left: 3px solid transparent;
                  border-right: 3px solid transparent;
                  border-top: 3px solid #333333;
                }
                &.active {
                  &::before {
                    transform: rotate(180deg);
                    top: 8px;
                  }
                }
              }
              .selice_box {
                position: absolute;
                right: 20px;
                top: 26px;
                z-index: 999;
                ul {
                  padding: 8px;
                  background: #ffffff;
                  border: 1px solid #e5e5e5;
                  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
                  border-radius: 6px;
                  box-sizing: border-box;
                  li {
                    padding: 8px 12px;
                    font-size: 14px;
                    color: #373a4d;
                    white-space: nowrap;
                    border-radius: 6px;
                    &.active {
                      background: #f7f7fc;
                      border: 1px solid #286df7;
                      color: #286df7;
                    }
                  }
                }
              }
            }
          }
          .line_box {
            width: 334px;
            height: 200px;
            margin: 0 auto;
          }
          .lhhcBtn {
            // padding: 8px 125px;
            width: 322px;
            border-radius: 4px;
            border: 1px solid #286df7;
            font-size: 12px;
            color: #286df7;
            margin: 0 auto;
            text-align: center;
            height: 33px;
            line-height: 33px;
          }
        }
      }
      .hcfx_box {
        width: 100%;
        padding: 4px 16px;
        padding-top: 10px;
        box-sizing: border-box;
        .head_box {
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          margin-bottom: 10px;
          span {
            color: #999;
            font-size: 12px;
            line-height: 22px;
            margin-left: 2px;
            font-weight: 400;
          }
        }
        table {
          tr {
            th {
              height: 25px;
              line-height: 25px;
              font-size: 12px;
              color: #999;
              text-align: center;
              border-bottom: 1px solid #f0f0f0;
              border-top: 1px solid #f0f0f0;
            }
            .zybox-list-left {
              // border: 1px solid red;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-content: center;
              justify-content: flex-start;
              align-items: center;
            }
            td {
              height: 45px;
              text-align: center;
              line-height: 44px;
              font-size: 14px;
              color: #555;
              border-bottom: 1px solid #f0f0f0;

              .zybox {
                // border: 1px solid red;
                // padding: 1px 3px;
                width: 18px;
                height: 30px;
                line-height: 14px;
                // font-size: 10px;
                // color: #fff;
                // border-radius: 2px;
                // display: block;
                // text-align: center;
                // line-height: 18px;
                display: inline-flex;
                padding: 2px 3px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                color: #fff;
                font-size: 10px;
                font-weight: 400;
                border-radius: 2px;
                margin-right: 4px;
                &.zf {
                  background: linear-gradient(270deg, #cd0000 0%, #f76825 100%);
                }
                &.gl {
                  background: linear-gradient(270deg, #e47813 0%, #ffbe5e 100%);
                }
              }
            }
          }
        }
      }
      .lsmx_box {
        width: 100%;
        padding-bottom: 8px;
        .header_box {
          padding: 16px 15px 15px 15px;
          font-size: 16px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .nav_box {
          width: 100%;
          padding: 4px 0 4px 12px;
          box-sizing: border-box;
          overflow: hidden;
          overflow-x: auto;
          white-space: nowrap;
          display: flex;
          li {
            width: 50px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            font-size: 12px;
            color: #555;
            border-radius: 4px;
            border: 1px solid #f0f0f0;
            margin-right: 8px;
            flex-shrink: 0;
            &.active {
              border: none;
              background: rgba(40, 109, 247, 0.1);
              color: #286df7;
              font-weight: 500;
            }
          }
        }
        .lsmxChart {
          width: 100%;
          padding: 8px 16px 16px 16px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          #chartLs,
          .right {
            width: 50%;
            height: 142px;
            margin-top: 10px;
            li {
              p {
                font-weight: 400;
                font-size: 12px;
                color: #555;
              }
            }
          }
          .right {
            line-height: 24px;
            li {
              display: flex;
              align-items: center;
              justify-content: space-between;
              p {
                display: flex;
                align-items: center;
                .dot {
                  width: 6px;
                  height: 6px;
                  border-radius: 50%;
                  margin-right: 3px;
                }
              }
            }
          }
        }
        .table_main {
          width: 100%;
          padding-bottom: 8px;
          table {
            tr {
              th {
                height: 25px;
                font-size: 12px;
                color: #999;
              }
              td {
                padding: 10px 0;
                text-align: center;
                p {
                  font-size: 12px;
                  color: #373a4d;
                  &:nth-child(1) {
                    margin-bottom: 4px;
                  }
                }
                &:nth-child(1) {
                  p {
                    &:nth-child(1) {
                      font-size: 14px;
                      color: #373a4d;
                      font-weight: 600;
                    }
                    &:nth-child(2) {
                      font-size: 12px;
                      color: #999;
                      // font-weight: 600;
                    }
                  }
                }
                &:nth-child(4) {
                  font-size: 14px;
                }
              }
            }
          }
        }
        .more_btn {
          width: 343px;
          height: 33px;
          text-align: center;
          line-height: 33px;
          border-radius: 4px;
          background: rgba(40, 109, 247, 0.06);
          font-size: 12px;
          color: #286df7;
          margin: 0 auto;
        }
      }
    }
  }

  // 页面滚动时触发的样式
  .contant_main {
    &.scrollBox {
      // overflow-y: auto;
      .main_all {
        padding-top: 36px;
        .nav_list_main {
          position: fixed;
          top: 88px;
          left: 0;
          background-color: #fff;
          z-index: 99;
          border-radius: 8px 8px 0px 0px;
        }
        .jrxh_box {
          .jrxhScroll_box {
            width: 100%;
            position: fixed;
            top: 124px;
            left: 0;
            background-color: #fff;
            z-index: 99;
            table {
              th {
                font-size: 12px;
                color: #999999;
                font-weight: 400;
                padding: 4px 0;

                &:first-child {
                  padding-left: 15px;
                  box-sizing: border-box;
                  text-align: left;
                  width: 25%;
                }
                &:last-child {
                  padding-right: 15px;
                  box-sizing: border-box;
                  text-align: right;
                  width: 20%;
                }
              }
            }
          }
        }
        .lsmx_box {
          .lsmxScorll_box {
            width: 100%;
            position: fixed;
            top: 124px;
            left: 0;
            background-color: #fff;
            z-index: 99;
            table {
              th {
                height: 25px;
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }
  .hd_not_box {
    padding-top: 70px;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    img {
      width: 180px;
      height: 120px;
      margin: 0 auto;
      margin-bottom: 11px;
    }
    .text_box {
      width: 268px;
      margin: 0 auto;
      font-size: 14px;
      color: #b8bbca;
      margin-bottom: 56px;
    }
    .link_text {
      font-size: 14px;
      color: #286df7;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
      img {
        width: 12px;
        height: 12px;
        margin: 0;
        margin-left: 8px;
      }
    }
    .btn_box {
      width: 200px;
      padding: 7px 0;
      border-radius: 6px;
      background: #2568eb;
      text-align: center;
      font-size: 14px;
      color: #fff;
      margin: 0 auto;
    }
  }
  .popup_box {
    .tit_box {
      width: 100%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      font-weight: 500;
      color: #222;
    }
    .type_tit {
      width: 100%;
      height: 38px;
      padding-left: 16px;
      line-height: 38px;
      font-size: 14px;
      color: #555;
    }
    .selice_content {
      width: 100%;
      padding: 4px 16px 20px;
      ul {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          display: inline-block;
          width: 108px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
          color: #222;
          background-color: #f1f0f5;
          border-radius: 4px;
          margin-bottom: 8px;
          &.active {
            border: 1px solid #286df7;
            background: #f1f0f5;
          }
        }
      }
    }
    .fod_btn_box {
      width: 100%;
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      div {
        width: 166px;
        height: 38px;
        text-align: center;
        line-height: 38px;
        border-radius: 6px;
        font-size: 16px;
      }
      .close_box {
        background-color: rgba(40, 109, 247, 0.1);
        color: #286df7;
      }
      .confirm_box {
        background-color: #286df7;
        color: #fff;
      }
    }
  }
}
.black_version {
  min-height: 100vh;
  background-color: #0c0f13;
  .sticky_header {
    .navg_box {
      background: url('../../assets/image/blockImg/bg.png') top no-repeat;
      background-size: 100%;
      .bg_box {
        background: url('../../assets/image/detail_top.png') top no-repeat;
        background-size: 100% 4.2rem;
      }
    }
  }
  header {
    background: url('../../assets/image/blockImg/bg.png') top no-repeat;
    background-size: 100%;
    .navget_main {
      color: #e4e9fe;
    }
    .hd_main {
      .cl_tit_main {
        .text {
          color: #e4e9fe;
        }
      }
      .introduce_box {
        color: #aab9d1;
      }
      .msg_main {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.1);
        ul {
          li {
            p {
              &:first-child {
                color: #e4e9fe;
              }
              &:last-child {
                color: #aab9d1;
              }
            }
          }
        }
      }
      .divisor_main {
        .tit_box {
          color: #e4e9fe;
        }
        .yzc_list {
          .li {
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: rgba(255, 255, 255, 0.1);
            color: #e4e9fe;
          }
        }
      }
    }
  }
  .contant_main {
    background: #0c0f13;
    .main_all {
      background-color: #181a23;
      .interval_box {
        background-color: #0c0f13;
      }
      .nav_list_main {
        li {
          color: #e4e9fe;
          &.active {
            color: #3b85fe;
            &::before {
              background: #3b85fe;
            }
          }
        }
      }
      .pj_main {
        .tit_box {
          p {
            color: #fff;
          }
        }
        .xx_list {
          ul {
            li {
              .left {
                color: #6b7687;
              }
              .right {
                color: #e4e9fe;
              }
            }
          }
        }
      }
      .hcsy_box {
        .tab_box {
          ul {
            li {
              color: #e4e9fe;
              &.active {
                color: #3b85fe;
                &::before {
                  content: ' ';
                  background: #3b85fe;
                }
              }
            }
          }
        }
      }
      .jrxh_box {
        .tit {
          color: #fff;
        }
        .table_content {
          table {
            th {
              color: #6b7687;
            }
            td {
              color: #e4e9fe;
              &:first-child {
                p {
                  &:first-child {
                    color: #e4e9fe;
                  }
                  &:last-child {
                    color: #6b7687;
                  }
                }
              }
              &:last-child {
                span {
                  background-color: rgba(59, 133, 254, 0.06);
                  color: #3b85fe;
                }
              }
            }
          }
          .more_btn {
            background: rgba(59, 133, 254, 0.2);
            color: #3b85fe;
          }
        }
      }
      .sy_main {
        .tit_box {
          color: #ffffff;
        }
        .cont_main {
          .tab_cont_box {
            span {
              color: #e4e9fe;
            }
          }
          .selice_main {
            .left_btn_main {
              span {
                border: 1px solid rgba(255, 255, 255, 0.2);
                color: #e4e9fe;
                &.active {
                  background: rgba(59, 133, 254, 0.2);
                  border: none;
                  color: #3b85fe;
                }
              }
            }
          }
        }
      }
      .hcfx_box {
        .head_box {
          color: #ffffff;
          span {
            color: #6b7687;
          }
        }
        table {
          tr {
            th {
              color: #6b7687;
              border-bottom: 1px solid rgba(255, 255, 255, 0.1);
              border-top: 1px solid rgba(255, 255, 255, 0.1);
            }
            td {
              color: #e4e9fe;
              border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }
          }
        }
      }
      .lsmx_box {
        .header_box {
          span {
            color: #e4e9fe;
          }
        }
        .nav_box {
          li {
            border: 1px solid rgba(255, 255, 255, 0.2);
            color: #e4e9fe;
            &.active {
              background: rgba(59, 133, 254, 0.2);
              color: #3b85fe;
            }
          }
        }
        .lsmxChart {
          .right {
            li {
              p {
                color: #e4e9fe;
              }
            }
          }
        }
        .table_main {
          table {
            tr {
              th {
                color: #6b7687;
              }
              td {
                p {
                  color: #e4e9fe;
                }
                &:nth-child(1) {
                  p {
                    &:nth-child(1) {
                      color: #e4e9fe;
                    }
                    &:nth-child(2) {
                      color: #6b7687;
                    }
                  }
                }
              }
            }
          }
        }
        .more_btn {
          background: rgba(59, 133, 254, 0.2);
          color: #3b85fe;
        }
      }
    }
    &.scrollBox {
      .main_all {
        .nav_list_main {
          background-color: #181a23;
        }
        .jrxh_box {
          .jrxhScroll_box {
            background-color: #181a23;
          }
        }
        .lsmx_box {
          .lsmxScorll_box {
            background-color: #181a23;
            table {
              th {
                color: #6b7687;
              }
            }
          }
        }
      }
    }
  }
  .popup_box {
    .tit_box {
      color: #e4e9fe;
    }
    .type_tit {
      color: #aab9d1;
    }
    .selice_content {
      ul {
        li {
          background-color: #2e3548;
          color: #e4e9fe;
          &.active {
            background-color: #2e3548;
            color: #3b85fe;
            border: 1px solid#3B85FE;
          }
        }
      }
    }
    .fod_btn_box {
      border: 1px solid rgba(255, 255, 255, 0.1);
      .close_box {
        background: rgba(59, 133, 254, 0.2);
        color: #3b85fe;
      }
      .confirm_box {
        background: #3b85fe;
        color: #ffffff;
      }
    }
  }
}
</style>
<style lang="less">
.van-popup {
  border-radius: 20px 20px 0px 0px;
  padding-top: 20px;
}
.black_version {
  .dialog_box {
    background-color: #181a23;

    .van-dialog__message {
      color: #aab9d1 !important;
    }
  }
  .van-button--default {
    background-color: #181a23;
    color: #3b85fe;
  }
  .van-popup {
    background-color: #1d202d;
  }
}
</style>
